import type { FilterType } from '@hotjar/global-filters';
import { getGlobalFiltersLabel } from '@hotjar/global-filters';

export const getStepSeriesLabel = (filterList: FilterType[]): string => {
  const result = getGlobalFiltersLabel(filterList);
  return result || 'Empty step';
};
